import { Map } from 'immutable'
import { GET_EVENTS_SUCCESS, TOGGLE_INVENTORY_ITEM } from '../actions/ActionTypes'

/**
 * The availability reducer is in the process of being mostly replaced by the inventory cart reducer.
 * This reducer should only contain availability IDs.
 */
const availability = (state = Map(), action) => {
  switch (action.type) {
    case GET_EVENTS_SUCCESS:
      return state.mergeDeep(action.data.availability)
    case TOGGLE_INVENTORY_ITEM:
      return state.updateIn([action.date, action.eventId], inventoryList =>
        inventoryList.map((inventoryEdit, inventoryId) => {
          if (inventoryId === action.inventoryId) {
            return inventoryEdit.set('isHighlighted', true)
          }
          return inventoryEdit.set('isHighlighted', false)
        })
      )
    default:
      return state
  }
}

export default availability
